import { create } from "zustand";
import {
  Appointment,
  CalendarEvent,
  Hours,
  Schedule,
  Service,
} from "../../../constants/model/models";
export interface BookingStepperFields {
  format: "online" | "onPremise";
  specialty: string;
  services: Service[];
  specialist?: Schedule;
}

export interface BookingForm {
  slotId: number | string;
  scheduleId: number | string;
  bookingName: string;
  remark: string | null;
  time: Hours;
  hour: Hours;
  bookedSpots: 1;
  date: string;
  slotStart: string;
  slotEnd: string;
  customerUid: string;
  listOfServices: string[] | null;
  slot: CalendarEvent;
  paymentRequest: AppointmentPaymentRequest;
  online: boolean;
}

export interface AppointmentPaymentRequest {
  paymentMethod: "MBWAY" | "MULTIBANCO" | "CREDIT_CARD";
  phoneNumber?: string;
  successUrl?: string;
  errorUrl?: string;
  cancelUrl?: string;
  language?: string;
  appointment?: Appointment;
}

interface BookingState {
  stepperFields: BookingStepperFields;
  activeIndex: number;
  bookingForm?: BookingForm;

  prepaymentStep?: boolean;

  updateIndex: (index: number) => void;
  updateStepperFields: (fields: BookingStepperFields) => void;
  updateBookingForm: (form: BookingForm | undefined) => void;

  errorMessage?: string;
  updateErrorMessage: (message: string) => void;
  resetStepperFields: () => void;
  setPrepaymentStep: (value: boolean) => void;

  amount: number;
  setAmount: (amount: number) => void;
}

export const bookingStore = create<BookingState>()((set) => ({
  amount: 0,
  stepperFields: {
    format: "onPremise",
    specialty: "",
    services: [],
  },
  activeIndex: 0,
  updateIndex: (index: number) =>
    set((state) => ({
      activeIndex: index,
    })),
  updateStepperFields: (fields: BookingStepperFields) =>
    set((state) => ({
      stepperFields: fields,
    })),
  updateBookingForm: (form: BookingForm | undefined) =>
    set((state) => ({
      bookingForm: form,
    })),
  updateErrorMessage: (message: string) =>
    set((state) => ({
      errorMessage: message,
    })),
  resetStepperFields: () =>
    set((state) => ({
      stepperFields: {
        format: "onPremise",
        specialty: "",
        services: [],
      },
    })),
  setPrepaymentStep: (value) =>
    set((state) => ({
      prepaymentStep: value,
    })),
  setAmount: (value) =>
    set((state) => ({
      amount: value,
    })),
}));
